import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { PlanoContaMatrizInserirRoutingModule } from "./plano-contas-matriz-inserir-routing.module";
import { PlanoContaMatrizInserirComponent } from "./plano-contas-matriz-inserir.component";

import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";
import { InputTextareaModule } from "primeng/inputtextarea";
import { HttpClientModule } from "@angular/common/http";
import { TooltipModule } from "primeng/tooltip";
import { DividerModule } from "primeng/divider";
import { DropdownModule } from "primeng/dropdown";
import { FormsModule } from "@angular/forms";
import { InputMaskModule } from 'primeng/inputmask';
import { MessagesModule } from 'primeng/messages';
import { InputSwitchModule } from "primeng/inputswitch";

@NgModule({
    imports: [
        CommonModule,            
        HttpClientModule,        
        ButtonModule,
        InputTextModule,
        TooltipModule,
        DividerModule,
        DropdownModule,
        FormsModule,
        InputTextareaModule,
        PlanoContaMatrizInserirRoutingModule,
        InputMaskModule,
        MessagesModule,
        InputSwitchModule
    ],
    declarations: [PlanoContaMatrizInserirComponent]
})
export class PlanoContaMatrizInserirModule { }
